import React from 'react'
import Head from 'next/head'

import Header from '@/partials/Header'
import Footer from '@/partials/FooterOLD2'
import TutorialsList from '@/partials/TutorialsList'
import Newsletter from '@/partials/Newsletter'
import YoutubeTutorialsList from '@/partials/YoutubeTutorialsList'
import TutorialsNewsletter from '@/partials/TutorialsNewsletter'
import TradlyFooter from '@/partials/TradlyFooter'

function Tutorials() {
  return (
    <>
      <Head>
        <meta
          key="twitter:title"
          name="twitter:title"
          content="Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
        />
        <meta
          key="og:title"
          property="og:title"
          content="Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
        />
        <title>Tradly – Tutorials</title>
      </Head>
      <div className="flex flex-col min-h-screen overflow-hidden">
        {/*  Site header */}
        {/* <Header /> */}

        {/*  Page content */}
        <main className="flex-grow">
          {/*  Page sections */}
          <YoutubeTutorialsList />
          {/* <TutorialsList /> */}

          {/* <Newsletter /> */}
          <TutorialsNewsletter />
        </main>

        {/*  Site footer */}
        <TradlyFooter />
      </div>
    </>
  )
}

export default Tutorials
